// @flow
import React from "react";
import "./styles.css";

type PropsType = { onClose: any => void };

export const ImageEditor = ({ onClose }: PropsType) => (
    <div className="widget-container">
        <div className="photo-widget is-column-layout">
            <div id="workspace" className="photo-widget_workspace">
                <div id="uploadInstructions" className="photo-widget_upload-instructions">
                    <p><span className="hasDrag">Drag a file here</span>
                        <span className="hasDrag">or</span>
                        <label>
                            <span className="hasDrag">select a file</span>
                            <span className="doesNotHaveDrag">Select a file to edit</span>
                            <input id="fileInput" type="file" accept="image/*"/>
                        </label>
                    </p>
                </div>
                <div id="editor" className="photo-widget_editor"/>
                <div id="spinner" className="spinner-box is-hidden">
                    <div className="spinner">
                        <span/>
                        <span/>
                        <span/>
                    </div>
                </div>
            </div>
            <div id="tools" className="photo-widget_tools">
                <div className="photo-widget_toolbar">
                    <div id="photoWidgetTabs" className="photo-widget_tabs">
                        <div className="photo-widget_tab">
                            <button id="toolSwitchScale" value="Scale" title="Scale Image" disabled="disabled"
                                    className="module-control-group_tool-switch">
                                <i className="icon-shrink"/>
                                <span className="-label">Scale</span>
                            </button>
                        </div>
                        <div className="photo-widget_tab">
                            <button id="toolSwitchCrop" value="Crop" title="Crop Image" disabled="disabled"
                                    className="module-control-group_tool-switch">
                                <i className="icon-crop"/>
                                <span className="module-control-group_tool-switch-label">Crop</span>
                            </button>
                        </div>
                        <div className="photo-widget_tab">
                            <button id="toolSwitchHistory" value="History" title="Image History" disabled="disabled"
                                    className="module-control-group_tool-switch">
                                <i className="icon-history"/>
                                <span className="module-control-group_tool-switch-label">History</span>
                            </button>
                        </div>
                        <div className="photo-widget_tab">
                            <button id="toolSwitchRotate" value="Rotate" title="Rotate Image" disabled="disabled"
                                    className="module-control-group_tool-switch">
                                <i className="icon-spinner11"/>
                                <span className="module-control-group_tool-switch-label">Rotate</span>
                            </button>
                        </div>

                        <div className="photo-widget_tab">
                            <button id="toolSwitchClear" value="Clear" title="Start Over" disabled="disabled"
                                    className="module-control-group_tool-switch">
                                <i className="icon-cancel-circle"/>
                                <span className="module-control-group_tool-switch-label">Reset</span>
                            </button>
                        </div>
                        <div className="photo-widget_tab">
                            <button
                                id="toolSwitchZoom"
                                value="Zoom"
                                title="Zoom Image"
                                disabled="disabled"
                                className="module-control-group_tool-switch">
                                <i className="icon-zoom-in"/>
                                <span className="module-control-group_tool-switch-label">Zoom</span>
                            </button>
                        </div>
                        <div className="photo-widget_tab">
                            <button id="toolSwitchSave" value="Save" title="Save Image" disabled="disabled"
                                    className="module-control-group_tool-switch">
                                <i className="icon-floppy-disk"/>
                                <span className="module-control-group_tool-switch-label">Save</span>
                            </button>
                        </div>
                        { Boolean(onClose) && (
                            <div className="photo-widget_tab">
                                <button
                                    id="toolSwitchSave"
                                    value="Save"
                                    title="Save Image"
                                    disabled={false}
                                    onClick={ onClose }
                                    className="module-control-group_tool-switch">
                                    <i className="icon-floppy-disk"/>
                                    <span className="module-control-group_tool-switch-label">Close</span>
                                </button>
                            </div>
                        ) }
                    </div>
                    <div className="photo-widget_tab-panels">
                        <div id="controlSetScale" className="photo-widget_control-group module-control-group">
                            <div className="module-control-group_container">
                                <div className="module-control-group_tool-group-container">
                                    <div className="module-control-group_tool-group-scale">
                                        <div className="module-slider-control">
                                            <em>1%</em>
                                            <input id="scaleImageControl" type="range" min="1" max="100"
                                                   value="100"/>
                                            <em>100%</em>
                                        </div>
                                        <div className="module-control-group_lower-control-container">
                                            <span className="module-control-group_control-value">
                                                <span id="scaleValue">100</span>
                                                <span>%</span>
                                            </span>
                                            <span className="module-control-group_group-name">Scale</span>
                                            <span className="module-control-group_resets">
                                                <button id="resetScale" title="Reset Scale" disabled="disabled">
                                                    <i className="icon-cancel-circle"/>
                                                </button>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div id="controlSetCrop" className="photo-widget_control-group module-control-group">
                            <div className="module-control-group_container">
                                <div className="module-control-group_tool-group-container">
                                    <div className="module-control-group_tool-group-crop">
                                        <div className="module-crop-control">
                                            <button className="module-control-group_start-button"
                                                    id="cropImageControl">
                                                <span>Crop</span>
                                            </button>

                                        </div>
                                        <div className="module-control-group_lower-control-container">
                                            <span className="module-control-group_group-name">Crop</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div id="controlSetHistory" className="photo-widget_control-group module-control-group">
                            <div className="module-control-group_container">
                                <div className="module-control-group_tool-group-container">
                                    <div className="module-control-group_tool-group-undo-redo">
                                        <div className="module-undo-redo-control">
                                            <button id="undoControl" title="Undo" disabled="disabled">
                                                <i className="icon-undo2"/>
                                            </button>
                                            <button id="redoControl" title="Redo" disabled="disabled">
                                                <i className="icon-redo2"/>
                                            </button>
                                        </div>
                                        <div className="module-control-group_lower-control-container">
                                            <span className="module-control-group_group-name">
                                                <label htmlFor="undoControl">
                                                    <span>Undo</span>
                                                </label>
                                                <label htmlFor="redoControl">
                                                    <span>Redo</span>
                                                </label>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div id="controlSetRotate" className="photo-widget_control-group module-control-group">
                            <div className="module-control-group_container">

                                <div className="module-control-group_tool-group-container">
                                    <div className="module-control-group_tool-group-rotate">

                                        <div className="module-rotate-control">
                                            <button id="rotateLeft" title="Rotate Left" value="-90">
                                                <i className="icon-undo"/>
                                            </button>
                                            <span className="module-photo-widget_rotation-value">
                                                <span id="rotationValue" className="photo-widget_control-value">0</span>
                                                <sup className="photo-widget_control-value">&deg;</sup>
                                            </span>
                                            <button id="rotateRight" title="Rotate Right" value="90">
                                                <i className="icon-redo"/>
                                            </button>
                                        </div>
                                        <div className="module-control-group_lower-control-container">
                                            <span className="module-control-group_group-name">Rotate</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div id="controlSetSave" className="photo-widget_control-group module-control-group">
                            <div className="module-control-group_container">
                                <div className="module-control-group_tool-group-container">
                                    <div className="module-control-group_tool-group-save">
                                        <div className="module-save-control">
                                            <a className="button" id="save" href="#" download={ true }>
                                                <i className="icon-floppy-disk"/>
                                            </a>
                                        </div>
                                        <div className="module-control-group_lower-control-container">
                                            <span className="module-control-group_group-name">Save!</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div id="controlSetClear" className="photo-widget_control-group module-control-group">
                            <div className="module-control-group_container">
                                <div className="module-control-group_tool-group-container">
                                    <div className="module-control-group_tool-group-reset">

                                        <div className="module-reset-control">
                                            <button id="clearImageControl">
                                                <i className="icon-cancel-circle"/>
                                            </button>
                                        </div>
                                        <div className="module-control-group_lower-control-container">
                                            <span className="module-control-group_group-name">Reset</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div id="controlSetZoom" className="photo-widget_control-group module-control-group">
                            <div className="module-control-group_container">
                                <div className="module-control-group_tool-group-container">
                                    <div className="module-control-group_tool-group-zoom">
                                        <div className="module-zoom-control">
                                            <em>1%</em>
                                            <input id="zoomControl" type="range" min="1" max="500" value="100"/>
                                            <em>500%</em>
                                            <button
                                                id="zoom50Button"
                                                value="50"
                                                title="Zoom 50%"
                                                disabled="disabled">50%
                                            </button>
                                            <button
                                                id="zoom200Button"
                                                value="200"
                                                title="Zoom 200%"
                                                disabled="disabled">
                                                200%
                                            </button>
                                            <button
                                                id="zoom500Button"
                                                value="500"
                                                title="Zoom 500%"
                                                disabled="disabled">
                                                500%
                                            </button>
                                        </div>
                                        <div className="module-control-group_lower-control-container">
                                            <span className="module-control-group_control-value">
                                                <span id="zoomValue">100</span>
                                                <span>%</span>
                                            </span>
                                            <span className="module-control-group_group-name">Zoom</span>
                                            <span className="module-control-group_resets">
                                                <button id="zoom100Button" value="100" title="Zoom 100%"
                                                        disabled="disabled">
                                                    <i className="icon-cancel-circle"/>
                                                </button>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
);